import { create } from "../../../../../common/utils/zustand_state_manager";

/**
 * State and actions
 */

type State = {
  name: string,
  description: string,
  status: number,
};

type Action = {
  setNameFilter: (p: string | ((p: string) => string)) => void,
  setDescriptionFilter: (p: string | ((p: string) => string)) => void,
  setStatusFilter: (p: number | ((p: number) => number)) => void,
};

/**
 * useFilters
 */

export const useFilters = create<State & Action>((set, get) => ({
  name: '',
  description: '',
  status: 0,
  setNameFilter: (p) => typeof p === 'function'
    ? set((s) => ({ name: p(s.name) }))
    : set((s) => ({ name: p })),
  setDescriptionFilter: (p) => typeof p === 'function'
    ? set((s) => ({ description: p(s.description) }))
    : set((s) => ({ description: p })),
  setStatusFilter: (p) => typeof p === 'function'
    ? set((s) => ({ status: p(s.status) }))
    : set((s) => ({ status: p })),
}));